namespace $.$$ {

	$mol_style_define( $shm_hitalama_map_page_arrows, {

		Missing_relation: {
			width: '2rem',
			height: '2rem',
			justifyContent: 'center',
			border: { radius: '50%' },
			box: { shadow: [{
				inset: false,
				x: 0,
				y: '1px',
				blur: '4px',
				spread: 0,
				color: $mol_theme.line,
			}] },
		},

	} )

}
